var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"information-showcase information-showcase--yellow-light",class:{ 'container': _vm.useContainer, 'redirect-block-select': _vm.blockParams?.isUrl },style:({
    'padding-top': _vm.paddingTop + 'px',
    'padding-bottom': _vm.paddingBottom + 'px',
    'background-color': _vm.useBackgroundColor
  }),on:{"click":function($event){return _vm.$emit('block:redirect')}}},[_c('div',{staticClass:"information-showcase__content"},[_c('h3',[_vm._v(_vm._s(_vm.mainFields.title?.value))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.mainFields.text?.value)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }